// extracted by mini-css-extract-plugin
export var defaultWrapper = "_lc-3";
export var downloadButton = "_lc-4";
export var fileContainer = "_lc-9 _lc-7";
export var fileContainerBase = "_lc-7";
export var fileContainerFixedHeight = "_lc-8 _lc-7";
export var fileInfo = "_lc-5";
export var fileInfoWidthRestricted = "_lc-6";
export var fileType = "_lc-1";
export var fileTypeName = "_lc-2";
export var image = "_lc-0";
export var link = "_lc-b";
export var overflowEllipsis = "_lc-a";